


import { useEffect, useState } from "react";
import { Popup } from "@/components/common/Popup";

import { CustomerInfo} from "@/components/customer/CustomerInfo";
import { CustomerItem } from "@/components/customer/CustomerItem";
import { SearchForm } from "@/components/common/SearchForm";
import { Trash2, Plus, ArrowDownNarrowWide, ArrowUpWideNarrow, LoaderCircle } from "lucide-react";

import { sortData } from "@/helper/sort";
import { SortCategory } from "@/helper/sort";
import { CustomerInfoSchema } from "@/components/customer/CustomerSchema";
import { useApiFetch } from "@/helper/apiFetch";

import { useTranslate } from "@/helper/translate";


// Utility: Filter search input
function applySearchFilter(data: CustomerInfoSchema[], query: string): CustomerInfoSchema[] {
  const term = query.trim().toLowerCase();
  return data.filter(item =>
    
    item.name.toLowerCase().includes(term)
  );
}


export function CustomerPage() {


    const { translate } = useTranslate();
  
  const colHeaders = [
    { name: translate("ui.select"), sort: "" }, 
    { name: translate("ui.media"), sort: "media" }, 
    { name: translate("ui.name"), sort: "name" }, 
    { name: translate("ui.address"), sort: "address" }, 
    { name: translate("ui.phone"), sort: "phone" }, 
    { name: translate("ui.email"), sort: "email" }, 
    { name: translate("ui.status_active"), sort: "IsActive" }
  ];

  const [isLoaded, setIsLoaded] = useState(false);

  const [customers, setCustomers] = useState<CustomerInfoSchema[]>([]);
    const [listMode, setListMode] = useState(false);
    const [onlyActive, setActive] = useState(true);
    const [searchText, setSearchText] = useState<string>("");
    const [editCustomerId, setEditCustomer] = useState<string | null>(null);
    const [selectedCustomers, setSelectedCustomers] = useState<string[]>([]);
    const [sortCategory, setSortCategory] = useState<SortCategory>();
    const apiFetch = useApiFetch();
    
    const handleSortCategoryChange = (newCategory: string | number) => {
        const newC :SortCategory={
          name: newCategory,
          direction: sortCategory?.name === newCategory ? !sortCategory?.direction : true
        }
        
        setSortCategory(newC);
        
        setCustomers(sortData(customers, newC));
      };

    const handleCheckChange = (id: string, checked: boolean) => {
      setSelectedCustomers(prev =>
        checked ? [...prev, id] : prev.filter(customerId => customerId !== id)
      );
    };
  
    const deleteCustomers = () => {

      selectedCustomers.map(customerId => {
      apiFetch(`/App/DeleteCustomer?customerId=${customerId}`, {
        method: "GET"
      }).then(res => {
        if (res.ok) {
          //remove from array
          setCustomers(prev => prev.filter(s => s.customerId   !== customerId));
          setSelectedCustomers(prev => prev.filter(s => s !== customerId));

        }
        else {
          res.text().then(text => {
            setCustomers((prev) =>
              prev.map((s) =>
                s.customerId === customerId ? { ...s, error: text } : s
              )
            );
          })
        }
      }).catch(err => {
        console.error(err);
      })
    });



    };


  const updateCustomer = (customer: CustomerInfoSchema|null) => {
    if(customer){
      if(editCustomerId == "")
        setCustomers(prev => [...prev, customer]);
      else
      setCustomers(prev =>
        prev.map(c => (c.customerId === customer.customerId ? customer : c))
      );
    }
    setEditCustomer(null);};


    const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      const form = e.currentTarget;
      const input = form.querySelector("input");
      setSearchText(input?.value.toLowerCase() || "");
    };
  
    const filteredData = applySearchFilter(customers, searchText);
    const customerItems = filteredData.map((item, index) => (
      item.isDeleted ? null : (
        <CustomerItem
          key={index}
          item={item}
          listMode={listMode}
          isSelected={selectedCustomers.includes(item.customerId)}
          onClick={() => setEditCustomer(item.customerId)}
          onCheckChange={handleCheckChange}
        />
      )
    ));

    useEffect(() => {
      setIsLoaded(false)
      apiFetch(`/App/GetCustomers`) 
        .then(res => {
          if (!res.ok) throw new Error("Failed to fetch");
          return res.json();
        })
        .then(data => {
          setCustomers(data);
          setIsLoaded(true);
        })
        .catch(err => {
          console.error(err);
          //setLoading(false);
        });
    }, []);
    
  return (
    <div className="h-[calc(100vh-60px)] flex flex-col">
      <div className="content-header flex justify-between pt-[0.6rem] pb-[0.6rem] px-8 bg-gray-100 dark:bg-zinc-900">
        <div className="flex items-center gap-4">
          <h1 className="font-bold text-2xl">{translate("ui.customers")}</h1>
          <Plus className="w-7 h-7 cursor-pointer bg-sky-600 hover:bg-sky-700 dark:bg-orange-400 dark:hover:bg-orange-500 rounded-full text-white dark:text-black" onClick={() => setEditCustomer("")} />
            {(selectedCustomers.length > 0) &&
          <Trash2 className="w-7 h-7 cursor-pointer bg-rose-600 hover:bg-rose-700 rounded-full text-white p-[3px]" onClick={deleteCustomers} />}
        </div>

        <SearchForm title={translate("ui.companysearch")} onSubmit={handleSearchSubmit} />

        {/* <div className="flex items-center gap-1">
          <Toggle
            title="Only Active"
            checked={onlyActive}
            onChange={(e) => setActive(e.target.checked)}
          />
         
          { <div className="w-8 ml-1 cursor-pointer">
            <GridIcon type="grid" active={listMode} size="28px" onClick={() => setListMode(true)} />
          </div>
          <div className="w-8 ml-1 cursor-pointer">
            <GridIcon type="list" active={!listMode} size="28px" onClick={() => setListMode(false)} />
          </div> }
        </div> */}
      </div>
{!isLoaded ? (
        <div className="w-full text-center my-10 flex items-center justify-center">{translate("common.loading")} <LoaderCircle className="ml-3 w-5 h-5 inline-block animate-spin" /></div>
      ) : (
      <div className="flex-1 overflow-auto px-10">
      {!listMode ? (
             <div className="overflow-x-auto my-10 border rounded-xl shadow-2xl border-gray-100 dark:border-zinc-600">
               <table className="table-auto w-full border-collapse">
                 <thead className="border-b border-gray-300 text-sm text-gray-600 dark:text-gray-50 dark:border-zinc-900">
                   <tr>
                   {colHeaders.map((header, index) => (
                  <th
                    key={index}
                    className={`py-2 ${index < 2 ? 'px-4' : 'px-4'} text-left cursor-pointer bg-gray-200 dark:bg-zinc-900`}
                    onClick={() => handleSortCategoryChange(header.sort)}
                  >
                    <div className=" flex items-center">
                    <nobr>{header.name}</nobr>
                    {sortCategory?.name === header.name ? (
                      sortCategory.direction ? (
                        <ArrowDownNarrowWide className="w-3 h-3"/>
                      ) : (
                        <ArrowUpWideNarrow className="w-3 h-3"/>
                      )
                    ) : <div className="w-3" />}
                    </div>
                  </th>
                ))}
                
                   </tr>
                 </thead>
                 <tbody>{customerItems}</tbody>
               </table>
             </div>
           ) : (
             <div className="content-body flex gap-4 flex-wrap">
               {customerItems}
             </div>
           )}
          
     </div>)}
         
     
           <Popup
             isOpen={editCustomerId !== null}
             onClose={() => setEditCustomer(null)}
             title={translate("ui.companyinfo")}
              className="w-[800px]"
           >
             <CustomerInfo onClose={(customer) => { updateCustomer(customer);}} customerId={editCustomerId ?? ""} />
           </Popup>
    </div>
  )
}

